import { render } from "./ComicView.vue?vue&type=template&id=4214edb3"
import script from "./ComicView.vue?vue&type=script&lang=js"
export * from "./ComicView.vue?vue&type=script&lang=js"

import exportComponent from "/media/shared/vue/comicviewer-with-router/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__